import {
    MenuItem,
    Select
} from "@mui/material";
import {
    parse,
    startOfMonth
} from "date-fns";

type MonthSelectProps = {
    availableMonths: Array<string>;
    earliestPossibleDate: Date;
    selectedMonth: string;
    setStartDate: (date: Date) => void;
    disabled?: boolean;
};

export const MonthSelect = (props: MonthSelectProps) => {
    const { availableMonths, earliestPossibleDate, selectedMonth, setStartDate, disabled } = props;
    return (
        <Select
            variant="standard"
            value={selectedMonth}
            onChange={(event) => {
                const selectedMonth = event.target.value as string;
                const month = parse(selectedMonth, "MMMM yyyy", new Date());
                const newStartDate = new Date(Math.max(earliestPossibleDate.getTime(), startOfMonth(month).getTime()));
                setStartDate(newStartDate);
            }}
            sx={{ ml: 2 }}
            renderValue={(value) => value}
            MenuProps={{
                slotProps: {
                    paper: {
                        sx: {
                            maxHeight: "250px"
                        }
                    }
                }
            }}
            disabled={disabled}
        >
            {availableMonths.map((month) => {
                return (
                    <MenuItem key={month} value={month}>
                        {month}
                    </MenuItem>
                );
            })}
        </Select>
    );
};